import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { GridModule } from "@progress/kendo-angular-grid";
import { VehicleSelectComponent } from "./vehicle-select.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        GridModule
    ],
    declarations: [
        VehicleSelectComponent
    ],
    exports: [
        VehicleSelectComponent
    ]
})
export class VehicleSelectModule { }
